'use strict';
import angular from 'angular';
import _ from 'lodash';

import audiencesListHtmlUrl from './views/audienceTargeting.list.html';

var app = angular.module('audience.targeting.component', []);

app.component('googleAdsAudTargeting', {
    bindings: {
        showActions: '=',
        selectedAudiences: '=',
        clusterId: '=',
        isFormEdit: '=',
        modelValue:'='
    },
    templateUrl: audiencesListHtmlUrl,

    // The controller that handles our component logic
    controller: function (ProductService, $ioAlert, $stateParams,ModalService,$modal) {
        var self = this;

        self.inMarketSearch = "";
        self.reMarketSearch = "";
        self.inMarketList = [];
        self.reMarketList = [];

        var handleExpandedItems = function (inMarket) {
            inMarket.selectedChildrens = [];
            if (inMarket.isChecked) {
                inMarket.status = '';
                inMarket.isChecked = false;
                var selIndex = _.findIndex(self.selectedAudiences.inMarketList, { id: inMarket.id });
                if (selIndex >= 0) {
                    self.selectedAudiences.inMarketList.splice(selIndex, 1);
                }
                if (inMarket.childrenList && inMarket.childrenList.length > 0) {
                    _.each(inMarket.childrenList, function (children) {
                        children.status = '';
                        children.isChecked = false;
                        inMarket.selectedChildrens.push(children);
                    })
                }
            } else {
                inMarket.status = 'selected';
                inMarket.isChecked = true;
                if (inMarket.childrenList && inMarket.childrenList.length > 0) {
                    _.each(inMarket.childrenList, function (children) {
                        children.status = 'selected';
                        children.isChecked = true;
                        inMarket.selectedChildrens.push(children);
                    })
                }
                self.selectedAudiences.inMarketList.push(inMarket);
            }
        }

        self.handleSelectSubInMarkets = function (item, inMarket) {
            if (inMarket.isChecked) {
                inMarket.status = '';
                inMarket.isChecked = false;
                var selIndex = self.selectedAudiences.inMarketList.indexOf(inMarket);
                var selIndex = _.findIndex(self.selectedAudiences.inMarketList, { id: inMarket.id });
                if (selIndex >= 0) {
                    self.selectedAudiences.inMarketList.splice(selIndex, 1);
                } else {
                    var parent = inMarket.parentId;
                    var selIndex = _.findIndex(self.selectedAudiences.inMarketList, { id: parent });
                    var index = _.findIndex(self.inMarketList, { id: parent });
                    if (index >= 0) {
                        var childIndex = _.findIndex(self.inMarketList[index].selectedChildrens, { id: inMarket.id });
                        if (childIndex >= 0) {
                            if (selIndex >= 0) {
                                self.selectedAudiences.inMarketList[selIndex].selectedChildrens.splice(childIndex, 1);
                                if (self.selectedAudiences.inMarketList[selIndex].selectedChildrens && self.selectedAudiences.inMarketList[selIndex].selectedChildrens.length == 0) {
                                    item.status = '';
                                    item.isChecked = false;
                                    self.selectedAudiences.inMarketList.splice(selIndex, 1);
                                }
                            }
                        }
                    }
                }
            } else {
                inMarket.status = 'selected';
                inMarket.isChecked = true;
                if (item.isChecked) {
                    item.selectedChildrens.push(inMarket);
                } else {
                    item.selectedChildrens = [];
                    item.status = 'selected';
                    item.isChecked = true;
                    item.selectedChildrens.push(inMarket);
                    self.selectedAudiences.inMarketList.push(item);
                }
            }
        }

        self.handleSelectInMarkets = function (inMarket) {
            var isValid = true;
            if(self.modelValue.ad_group && self.modelValue.ad_group.length > 0){
                _.each(self.modelValue.ad_group,function(item){
                    if(item.inMarketList.length > 0 || item.reMarketList.length >0){
                        inMarket.isChecked = false;
                        isValid = false;
                        $ioAlert.show('Error:',"This campaign is already using audience targeting. Please remove the audience segments from Ad Group level before adding audience targeting to Campaign level.", 'error');
                    }
                })
            }
            if(isValid){
                if (inMarket.isExpand) {
                    handleExpandedItems(inMarket);
                } else {
                    inMarket.selectedChildrens = [];
                    if (!inMarket.isChecked) {
                        inMarket.status = '';
                        inMarket.isChecked = false;
                        var selIndex = self.selectedAudiences.inMarketList.indexOf(inMarket);
                        if (selIndex >= 0) {
                            self.selectedAudiences.inMarketList.splice(selIndex, 1);
                        } else {
                            if (self.selectedAudiences.inMarketList && self.selectedAudiences.inMarketList.length > 0) {
                                if (_.find(self.selectedAudiences.inMarketList, { id: inMarket.id })) {
                                    var index = _.findIndex(self.selectedAudiences.inMarketList, { id: inMarket.id });
                                    self.selectedAudiences.inMarketList.splice(index, 1);
                                }
                            }
                        }
                    } else {
                        inMarket.status = 'selected';
                        inMarket.isChecked = true;
                        self.selectedAudiences.inMarketList.push(inMarket);
                    }
                }
            }
        }

        self.removeSubInMarkets = function (subList, selectedInMarkets, marketsList) {
            var parent = subList.parentId;
            var selIndex = _.findIndex(selectedInMarkets, { id: parent });
            var index = _.findIndex(marketsList, { id: parent });
            if (index >= 0) {
                var childIndex = _.findIndex(marketsList[index].selectedChildrens, { id: subList.id });
                var childListIndex = _.findIndex(marketsList[index].childrenList, { id: subList.id });
                if (childIndex >= 0) {
                    marketsList[index].childrenList[childListIndex].status = '';
                    marketsList[index].childrenList[childListIndex].isChecked = false;
                    if (selIndex >= 0) {
                        selectedInMarkets[selIndex].selectedChildrens.splice(childIndex, 1);
                    }
                }
            }
        }

        /*
        * Handle remove In-Markets
        */
        self.removeInMarkets = function (item, selectedInMarkets, marketsList) {
            if (_.has(item, 'parentId')) {
                var selIndex = selectedInMarkets.indexOf(item);
                if (selIndex >= 0) {
                    selectedInMarkets.splice(selIndex, 1);
                    item.status = '';
                    item.isChecked = false;
                }
            } else {
                var selIndex = selectedInMarkets.indexOf(item);
                if (selIndex >= 0) {
                    selectedInMarkets.splice(selIndex, 1);
                }
                var index = _.findIndex(marketsList, { id: item.id });
                if (index >= 0) {
                    marketsList[index].status = '';
                    marketsList[index].isChecked = false;
                    if (marketsList[index].childrenList && marketsList[index].childrenList.length > 0) {
                        _.each(marketsList[index].childrenList, function (children) {
                            children.status = '';
                            children.isChecked = false;
                        })
                    }
                }
            }
        }

        /*
        * Get In-Market lookup contents
        */
        self.getInMarketContents = function () {
            ProductService.getDevicesByContentKey({ clusterId: self.clusterId, contentKey: 'google_ads_inmarket_category' }).then(function (success) {
                if (success && success.lookupContents && success.lookupContents.length > 0) {
                    _.each(success.lookupContents, function (content) {
                        var inMarkets = {};
                        inMarkets.id = content.id;
                        inMarkets.name = content.lookup_value;
                        inMarkets.status = "";
                        inMarkets.isChecked = false;
                        inMarkets.isExpand = false;
                        if (self.editMode) {
                            ProductService.getInMarketValuesByParent({ parent_id: content.id,order_id: $stateParams.orderId }).then(function (success) {
                                if (inMarkets.isChecked && success && success.values && success.values.length > 0) {
                                    inMarkets.isExpand = true;
                                } else {
                                    inMarkets.isExpand = false;
                                }
                            }, function (error) { });
                        }
                        inMarkets.childrenList = [];
                        inMarkets.selectedChildrens = [];
                        self.inMarketList.push(inMarkets);
                    });
                    processInMarketsData();
                }
            }, function (error) { });
        }

        /*
        * get sub in-market contents
        */
        self.getSubInMarketList = function (category, isExpand) {
            ProductService.getInMarketValuesByParent({ parent_id: category.id,order_id: $stateParams.orderId }).then(function (success) {
                if (self.editMode && !category.isExpand && category.isChecked && success && success.values && success.values.length == 0) {
                    return;
                } else if (success && success.values && success.values.length > 0) {
                    category.childrenList = [];
                    _.each(success.values, function (content) {
                        var inMarket = {};
                        inMarket.id = content.id;
                        inMarket.name = content.value;
                        inMarket.status = "";
                        inMarket.isChecked = false;
                        inMarket.parentId = category.id;
                        category.childrenList.push(inMarket);
                    })
                    if (category.selectedChildrens && category.selectedChildrens.length > 0) {
                        _.each(category.selectedChildrens, function (children) {
                            _.each(category.childrenList, function (catChild) {
                                if (catChild.id == children.id) {
                                    catChild.status = 'selected';
                                    catChild.isChecked = true;
                                }
                            })
                        })
                    } else if (category.isChecked && category.childrenList && category.childrenList.length > 0) {
                        _.each(category.childrenList, function (children) {
                            children.isChecked = true;
                            children.status = "selected";
                            category.selectedChildrens.push(children);
                        })
                    }

                    category.isExpand = true;
                } else {
                    $ioAlert.show('Error!', 'No subcategories are available for this ' + category.name + ' category', 'error');
                }
            }, function (error) { });
        }

        var processInMarketsData = function () {
            if (self.editMode && self.selectedAudiences) {
                var inMarketsList = [];
                var subInMarketsList = [];

                if ((self.selectedAudiences.inMarketList && self.selectedAudiences.inMarketList.length > 0)) {
                    inMarketsList = self.inMarketList;
                    subInMarketsList = self.selectedAudiences.inMarketList;
                    processCategories(inMarketsList, subInMarketsList);
                }
            }
        }

        var processCategories = function (totalList, subList) {
            _.each(subList, function (subInMarket) {
                if (_.has(subInMarket, 'parentId')) {
                    var parentElement = _.find(totalList, { id: subInMarket.parentId });
                    if (parentElement) {
                        parentElement.selectedChildrens.push(subInMarket);
                    }
                    self.getSubInMarketList(parentElement);

                } else {
                    var parentElement = _.find(totalList, { id: subInMarket.id });
                    if (parentElement) {
                        parentElement.isChecked = true;
                        parentElement.status = 'selected';
                        parentElement.selectedChildrens = subInMarket.selectedChildrens;
                    }
                    self.getSubInMarketList(parentElement);
                }
            })
        }


        // Re-Market List Widget code implementation
        /*
        * Get Re-Market List values
        */
        self.getReMarketList = function () {
            ProductService.getReMarketListValues({ order_id: $stateParams.orderId }).then(function (success) {
                if (success && success.values && success.values.length > 0) {
                    _.each(success.values, function (content) {
                        var reMarkets = {};
                        reMarkets.id = content.id;
                        reMarkets.name = content.name;
                        reMarkets.status = "";
                        reMarkets.isChecked = false;
                        self.reMarketList.push(reMarkets);
                    });
                    processReMarketsData();
                }
            }, function (error) { });
        }

        /*
        * Process Re-Market List Data
        */
        var processReMarketsData = function () {
            if (self.editMode && self.selectedAudiences) {
                var reMarketsList = [];
                if ((self.selectedAudiences.reMarketList && self.selectedAudiences.reMarketList.length > 0)) {
                    reMarketsList = self.reMarketList;
                    processReMarketList(reMarketsList, self.selectedAudiences.reMarketList);
                }
            }
        }

        /*
        * Process Re-Market List
        */
        var processReMarketList = function (totalList, selectedList) {
            _.each(selectedList, function (subReMarket) {
                var parentElement = _.find(totalList, { id: subReMarket.id });
                if (parentElement) {
                    parentElement.isChecked = true;
                    parentElement.status = 'selected';
                }
            })
        }

        /*
        * Handle selected Re-Markets
        */
        self.handleSelectReMarkets = function (reMarket, selectedReMarkets, marketsList) {
            var isValid = true;
            if(self.modelValue.ad_group && self.modelValue.ad_group.length > 0){
                _.each(self.modelValue.ad_group,function(item){
                    if(item.inMarketList.length > 0 || item.reMarketList.length >0){
                        reMarket.isChecked = false;
                        isValid = false;
                        $ioAlert.show('Error:',"This campaign is already using audience targeting. Please remove the audience segments from Ad Group level before adding audience targeting to Campaign level.", 'error');
                    }
                })
            }
            if(isValid){
                if (!reMarket.isChecked) {
                    reMarket.status = '';
                    reMarket.isChecked = false;
                    var selIndex = self.selectedAudiences.reMarketList.indexOf(reMarket);
                    if (selIndex >= 0) {
                        self.selectedAudiences.reMarketList.splice(selIndex, 1);
                    } else {
                        if (self.selectedAudiences.reMarketList && self.selectedAudiences.reMarketList.length > 0) {
                            if (_.find(self.selectedAudiences.reMarketList, { id: reMarket.id })) {
                                var index = _.findIndex(self.selectedAudiences.reMarketList, { id: reMarket.id });
                                self.selectedAudiences.reMarketList.splice(index, 1);
                            }
                        }
                    }
                } else {
                    reMarket.status = 'selected';
                    reMarket.isChecked = true;
                    self.selectedAudiences.reMarketList.push(reMarket);
                }
            }
        }

        /*
        * Handle remove Re-Markets
        */
        self.removeReMarkets = function (item, selectedReMarkets, marketsList) {
            if (_.has(item)) {
                var selIndex = selectedReMarkets.indexOf(item);
                if (selIndex >= 0) {
                    selectedReMarkets.splice(selIndex, 1);
                    item.status = '';
                    item.isChecked = false;
                }
            } else {
                var selIndex = selectedReMarkets.indexOf(item);
                if (selIndex >= 0) {
                    selectedReMarkets.splice(selIndex, 1);
                }
                var index = _.findIndex(marketsList, { id: item.id });
                if (index >= 0) {
                    marketsList[index].status = '';
                    marketsList[index].isChecked = false;
                }
            }
        }

        self.openHelperTextPopup = function(){
            $modal.open(
                ModalService.returnModalType('showHelpertexts')
            ).result.then(function (res) {
                var test = res;
            });
        }

        self.initComponent = function () {
            if (self.selectedAudiences && !_.isEmpty(self.selectedAudiences)) {
                self.selectedAudiences = JSON.parse(self.selectedAudiences);
                if (self.showActions) {
                    self.editMode = true;
                    self.enableViewMode = false;
                    self.getInMarketContents();
                    self.getReMarketList();
                } else {
                    self.editMode = false;
                    self.enableViewMode = true;
                }
            } else {
                self.selectedAudiences = {
                    inMarketList: [],
                    reMarketList: [],
                    enableBidAmount:false,
                    bidType:'bid_only'
                };
                self.enableViewMode = false;
                self.getInMarketContents();
                self.getReMarketList();
            }
        };

        self.initComponent();
    }
});